exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-reporting {\n  float: right;\n  position: relative;\n  top: 3px;\n  font-size: 0.9em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/router-tabs/router-tabs.component.less
// module id = ../../../../../src/app/shared/tabs/router-tabs/router-tabs.component.less
// module chunks = 2